import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Register } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { filter, pairwise, take } from 'rxjs/operators';
import { Router, RoutesRecognized } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  public url: string = 'https://yadeyaencasa.com/api/';
  //public url: string = 'https://desarrollaya.angelplus.es/api/';
  public lastUrl: string;
  public role: string;

  constructor(
    public user: UserService,
    private geolocation: Geolocation,
    private http: HttpClient,
    private router: Router,
  ) { }

  ngOnInit(){
    
  }

  geoLocate(){
    this.geolocation.getCurrentPosition().then((resp) => {

      this.coordsPost(resp.coords).subscribe();

     }).catch((error) => {});
  }

  getAdress(){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);


    return this.http.get(this.url + 'read_address', { headers: headersData} );
  }

  getAdress2(){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const promise = this.http.get(this.url + 'read_address', { headers: headersData }).toPromise();
    return promise;
  }

  addAdress(adress,number, door, postal_code, lat, lng){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData();
    formdata.append('address', adress);
    formdata.append('number', number);
    formdata.append('door', door);
    formdata.append('postal_code', postal_code);
    formdata.append('lat', lat);
    formdata.append('lng', lng);


    return this.http.post(this.url + 'new_address_v2', formdata, { headers: headersData} );
  }

  valoration( id_delivery, valoration, valoration_text ,valoration_product , valoration_product_text){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData();
    formdata.append('valoration', valoration);
    formdata.append('valoration_text', valoration_text);
    formdata.append('valoration_product', valoration_product);
    formdata.append('valoration_product_text', valoration_product_text);

    return this.http.post(this.url + 'valorate_delivery/' + id_delivery, formdata, { headers: headersData} );
  }

  predeterminateAdress(id_address){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

      const formdata = new FormData();

    return this.http.post(this.url + 'primary_address/' + id_address, formdata, { headers: headersData} );
  }

  removeAdress(id_address){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData(); 

    return this.http.post(this.url + 'remove_address/' + id_address, formdata, { headers: headersData} );
  }

  coordsPost(coords){

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData();
    formdata.append('lat', coords.latitude);
    formdata.append('lng', coords.longitude);

    return this.http.post(this.url + 'track_deliveryman', formdata, { headers: headersData} );
  }

  getDeliveryPrice(commerce, postal_code, total){

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    if (commerce === undefined || commerce === null){ commerce = 0; }

    return this.http.get(this.url + 'get_delivery_price/' + commerce + '/' + postal_code + '/' + total, { headers: headersData} );
  }

  ObtenerNotificaciones(){
    if (this.user.isLoggedIn === true){
      const headersData = new HttpHeaders()
        .append('Authorization', 'Bearer ' + this.user.data.token); 
      return this.http.get(this.url + 'notifications', { headers: headersData} );
    }
    let itemToReturn = new Observable();
    return itemToReturn;
  }

  GetObtenerNotificaciones(){
    if( this.user.data !==  undefined){
      this.ObtenerNotificaciones().subscribe((data) => {
        this.user.notifications = data['data'];
        this.user.home_message = data['home_message'];
      });
    }
  }

  TrampitaGetObtenerNotificaciones(token){
    
    const headersData = new HttpHeaders()
        .append('Authorization', 'Bearer ' + token); 

    return this.http.get(this.url + 'notifications', { headers: headersData} );
  }

  GetTrampitaGetObtenerNotificaciones(token){
    this.TrampitaGetObtenerNotificaciones(token).subscribe((data) => {
      this.user.notifications = data['data'];
      this.user.home_message = data['home_message'];
    });
  }

  LeerNotificaciones(notificacion_id){

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData();

    return this.http.post(this.url + 'read_notification/' + notificacion_id, formdata, { headers: headersData} );
  }

  MyProfile(){

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();
    formdata.append('name', this.user.data.name);
    formdata.append('last_name', this.user.data.last_name);
    formdata.append('email', this.user.data.email);
    formdata.append('phone', this.user.data.phone);
    
    return this.http.post(this.url + 'my_profile_post', formdata, { headers: headersData} );
  }

  Login() {

    const formdata = new FormData();
    formdata.append('email', this.user.auth.email);
    formdata.append('password', this.user.auth.pass);

    return this.http.post(this.url + 'login', formdata);
  }

  RecoverPass(email) {

    const formdata = new FormData();
    formdata.append('email', email);

    return this.http.post(this.url + 'rememberpass', formdata);
  }

  LoginFB(email,name) {

    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('name', name);
    formdata.append('login_type', 'Facebook');

    return this.http.post(this.url + 'login', formdata);
  }

  LoginApple(identityToken,email,name) {

    const formdata = new FormData();
    formdata.append('identityToken', identityToken);
    formdata.append('email', email);
    formdata.append('name', name);
    formdata.append('login_type', 'Apple');

    return this.http.post(this.url + 'login', formdata);
  }

  Register(user: Register, lat = null, lng  = null){

    const formdata = new FormData();
    formdata.append('email', user.email);
    formdata.append('name', user.name);
    formdata.append('last_name', user.last_name);
    formdata.append('password', user.pass);
    formdata.append('password_repeat', user.pass_repeat);
    formdata.append('phone', user.phone);
    formdata.append('address', user.address);
    formdata.append('number', user.number);
    formdata.append('door', user.door);
    formdata.append('postal_code', user.postal_code); 
    formdata.append('lat', lat);
    formdata.append('lng', lng);

    return this.http.post(this.url + 'register', formdata);
  }

  ObtenerPedidos() {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);


    return this.http.get(this.url + 'deliveries', { headers: headersData});
  }

  CanjearCuponV2(cupon, precio_sin_reparto = null, cart = null, client_id = null, postal_code = null, commerce_id = null, take_away = null, id_address = null, direccion = null, lat = null, lng = null) {
    const formdata = new FormData();
    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + this.user.data.token);
    formdata.append('code', cupon);
    formdata.append('cart', cart);
    formdata.append('client_id', client_id);
    formdata.append('postal_code', postal_code);
    formdata.append('commerce_id', commerce_id);
    formdata.append('price', precio_sin_reparto);
    formdata.append('take_away', take_away);
    formdata.append('id_address', id_address);
    formdata.append('address', direccion);
    formdata.append('lat', lat);
    formdata.append('lng', lng);



    return this.http.post(this.url + 'apply_coupon_v2', formdata, { headers: headersData});
  }


  ObtenerEstablecimientos() {
    return this.http.get(this.url + 'commerces');
  }


  ObtenerEstablecimiento(id) { 
    return this.http.get(this.url + 'commerce/' + id);
  }

  ObtenerEstados(){

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);


    return this.http.get(this.url + 'states', { headers: headersData});
  }

  // CAMBIOS DE ESTADOS

  EnviarPedido(cart, total, totalOrder, user_id, id_address, address, door = null, number, postal_code, observations, takeAway, coupon, client_time, lat = null, lng = null, client_id = null) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();
    formdata.append('cart', JSON.stringify(cart));
    formdata.append('price', total);
    formdata.append('total', totalOrder);
    formdata.append('user_id', user_id);
    formdata.append('client_id', client_id);

    if ( address === '' || address === undefined ){ address = ''; }

    if ( postal_code === '' || postal_code === undefined ){
      postal_code = this.user.data.postal_code;
    }
    formdata.append('address', address);      
    formdata.append('postal_code', postal_code);
    formdata.append('observations_client', observations);
    formdata.append('take_away', takeAway);

    if ( coupon === undefined ){
      coupon = '';
    }

    formdata.append('coupon', coupon);
    formdata.append('client_time', client_time);
    formdata.append('client_id', this.user.data.id + '');
    formdata.append('lat', lat);
    formdata.append('lng', lng);
    formdata.append('id_address', id_address);
    formdata.append('door', door);
    formdata.append('number', number);

    return this.http.post(this.url + 'new_order_desglosado' , formdata, { headers: headersData} );

  }

  AceptarPedido(idDelivery) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);

    const formdata = new FormData();

    return this.http.post(this.url + 'accepted/' + idDelivery , formdata, { headers: headersData} );
  }

  LlegadaLocal(idDelivery) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();

    return this.http.post(this.url + 'local_arrive/' + idDelivery , formdata , { headers: headersData} );
  }

  SalidaLocal(idDelivery) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();

    return this.http.post(this.url + 'local_exit/' + idDelivery , formdata , { headers: headersData} );
  }

  Entregar(idDelivery) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();

    return this.http.post(this.url + 'delivered/' + idDelivery , formdata  , { headers: headersData} );
  }

  Rechazar(idDelivery) {

    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    const formdata = new FormData();

    return this.http.post(this.url + 'reject/' + idDelivery , formdata , { headers: headersData} );
  }

    
  Menu(id:number){
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.user.data.token);
    return  this.http.get(this.url+'menu/'+id, {headers:headersData})
  
  }

  twoWorlds(){
    return this.http.get(this.url+'typologies');
  }

  getEstablecimientosCercanos(address, id, cp, lat, lng){
    const formdata = new FormData();
    const latlng = lat + "," +  lng;
    formdata.append('address', address);
    formdata.append('typology', id);
    formdata.append('postal_code', cp);
    formdata.append('latlng', latlng);

    return this.http.post(this.url+'nearby_commerces',formdata)
  }
    

}
